export default __webpack_public_path__ + "static/media/p-ANTONIO.71489353.png";